import { useEffect } from "react";
import type { LastBotCore } from "../core/LastBotCore";

/**
 * Reports default-UI panel readiness into core (LAS-2166): acks
 * `state.ui.panelInteractive = true` once the calling component has mounted
 * and its effects have flushed, and `false` from unmount cleanup.
 * `core.open()`'s promise (and embedder `when()` predicates) resolve on this
 * flag.
 *
 * Ordering contract: call this hook AFTER the component's other effects are
 * declared. React runs a component's effects in declaration order, so
 * listeners registered by earlier effects (ChatWidget's `nav:*`
 * subscriptions) are guaranteed attached before the ack flips true — that
 * guarantee is exactly what makes `await core.open(); core.showPage("history")`
 * deterministic.
 */
export const usePanelInteractiveAck = (core: LastBotCore): void => {
  useEffect(() => {
    core._setPanelInteractive(true);
    return () => {
      core._setPanelInteractive(false);
    };
  }, [core]);
};
